import { useSelector } from '../components/runtime-context';
import { getCurrentMatch } from './router-selectors';

export const useMatchedRoute = () => {
  return useSelector(getCurrentMatch);
};
